<!-- 车位变更信息上报 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "cmd": "reportParkinglotChange",
                "parkCode": "2KMRU4F",
                "parkinglotNO": "12",
                "type": 0,
                "triggerTime": "2019-07-16 00:00:00",
                "lockKey": "2420e3efbf6124c7185365b79c75c0f5be61a049"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报mpgs车位信息变更情况到第三方接入系统。信息包括某车位由空状态转换为车辆占用状态时间，某车位由车辆占用状态转换为空车位时间等信息",
                urlPattern:this.commonUrls.third+"reportParkinglotChange",
                precondition: "无",
                fitSystem: "部署上线MPGS停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                        { info1: 'parkinglotNO', info2: '是', info3: 'String', info4: '车位编号' },
                        { info1: 'type', info2: '是', info3: 'Integer', info4: '出发类型。0车位由占用转空 1车位由空转占用' },
                        { info1: 'triggerTime', info2: '是', info3: 'String', info4: '触发时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/parking/guide/reportParkinglotChange.vue